import { render, staticRenderFns } from "./ExpansionContent.vue?vue&type=template&id=b202502e&"
import script from "./ExpansionContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExpansionContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ExpansionContent.vue?vue&type=style&index=0&id=b202502e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports